import CorporationLinkData from '@/ts/CorporationLinkData';
import axios from 'axios';
import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Endpoints, Mutations, Actions } from '@/ts/store/Constants';

@Module({name: 'CorporationLinks', namespaced: true})
export default class CorporationLinks extends VuexModule {
    public userCorporationLinks: CorporationLinkData[] = [];

    get getUserCorporationLinks() {
        return this.userCorporationLinks;
    }

    //User
    @Action
    public FETCH_USER_CORPORATION_LINKS() {
        axios.get(Endpoints.CorporationLinks.USER_CORPORATION_LINKS)
            .then((response) => {
                if (response.data !== null) {
                    store.commit(Mutations.SET_CORPORATION_LINKS, {links: response.data.data});
                }
            })
            .catch((error) => {
                if (error.status === 401) {
                    store.dispatch(Actions.HANDLE_401);
                }
            }).then(() => {
            });

        return Promise.resolve();
    }

    @Mutation
    public SET_CORPORATION_LINKS(data: any): void {
        this.userCorporationLinks = [];
        for (const link of data.links) {
            this.userCorporationLinks.push(new CorporationLinkData(
                link.id,
                link.key,
                link.languageVersions,
                link.createdAt,
                link.updatedAt,
            ));
        }
    }

}